import { Triangle } from 'lucide-react';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '@/components/ui/tooltip';

interface PolygonModeToggleProps {
  isEnabled: boolean;
  onToggle: (value: boolean) => void;
}

export function PolygonModeToggle({
  isEnabled,
  onToggle,
}: PolygonModeToggleProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={() => onToggle(!isEnabled)}
            className={`flex h-7 w-7 items-center justify-center rounded transition-opacity hover:opacity-100 ${
              isEnabled ? 'opacity-100' : 'opacity-30'
            }`}
            aria-label="Toggle Polygon Mode"
          >
            <Triangle className="h-4 w-4 text-foreground" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="flex items-center gap-2 border-border bg-background text-foreground"
        >
          <span>Polygon Mode</span>
          <kbd className="rounded border border-border bg-muted px-1 font-mono text-xs text-muted-foreground">
            P
          </kbd>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
